import {Component, Input, OnInit} from '@angular/core';
import {InteractionDto} from 'src/app/modules/conference/models/card.model';
import {ConferenceService} from 'src/app/modules/conference/service/conference.service';

@Component({
  selector: 'app-journey-list-template-interaction',
  templateUrl: './list-template-interaction.component.html',
  styleUrls: ['./list-template-interaction.component.scss']
})
export class LearningJourneyListTemplateInteractionComponent implements OnInit {
  constructor(
      private conferenceService: ConferenceService,
  ) {}

  @Input() interactionId: any;
  @Input() userId: any;

  interaction: InteractionDto | null = null;

  ngOnInit(): void {
    this.conferenceService.getUserCards(this.interactionId, this.userId).then(res => {
      this.interaction = res;
    })
  }
}
